module.exports = __webpack_public_path__ + "img/picture_ksdgfz01.e500a8d6.png";